import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

// Holds the header shown for the "Challan Activity" tab so the global TabsComponent can
// reflect the activity type selected inside ChallanActivityComponent. The tab label is
// REPLACED with the selected Act's full name (e.g. "Employee Provident Fund Act").
@Injectable({ providedIn: 'root' })
export class ChallanActivityTitleService {
  private titleSubject = new BehaviorSubject<string>('');
  title$: Observable<string> = this.titleSubject.asObservable();

  // Maps the activity type (PF / ESIC / PT) to the full Act name shown as the tab header.
  private static readonly TITLE_MAP: { [key: string]: string } = {
    PF: 'Employee Provident Fund Act',
    ESIC: 'Employee State Insurance Act',
    PT: 'Professional Tax',
  };

  // Set the tab header to the selected Act's full name (empty => fall back to "Challan Activity").
  setActivityType(type: string): void {
    this.titleSubject.next(type ? (ChallanActivityTitleService.TITLE_MAP[type] || '') : '');
  }

  reset(): void {
    this.titleSubject.next('');
  }
}
